<template>
  <div :class="$style.mailto">
    <p :class="$style.mailText">Или пишите/звоните нам</p>
    <div :class="$style.bottomLinkWrap">
      <template v-for="(contact, index) in contacts">
        <a
          :key="index"
          :class="$style.mailLink"
          :aria-label="contact.title"
          :href="contact.value"
        >
          {{ contact.title }}
        </a>
        <br
          v-if="index === 0"
          :key="`${index}-br`">
        <span
          v-if="index !== 0 && index < contacts.length - 1"
          :key="`${index}-hr`"
          :class="$style.linkDelimiter"
        >|</span>
      </template>
    </div>
  </div>
</template>

<script>
import { contacts } from 'data/mockCommonInfo';

export default {
  name: 'ContactsListBlock',
  data() {
    return {
      contacts,
    };
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

.mailto {
  text-align: center;
}

.bottomLinkWrap {
  display: inline-block;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;

  @media (max-width: 480px) {
    border-bottom: 0 solid transparent;
  }
}

.mailText {
  @include set-fz-lh(16, 20);
  color: $gray-dark;
  opacity: 0.8;
}

.linkDelimiter {
  padding: 0 10px;

  @media (max-width: 480px) {
    display: none;
  }
}

.mailLink {
  @include set-fz-lh(16, 20);
  color: $black;
  transition: color 0.3s;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  margin-top: 20px;

  @include on-event() {
    color: $black;
  }

  @media (max-width: 480px) {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactsListBlock.vue